import urlJoin from './helpers/urlJoin';
import domain from '@framework/config/domain';
import assetsConfig from '@framework/config/assets';
import isServer from '@framework/router/Next/isServer';

const PROXY_API = '/proxy/api';
const REST_URL = `${ domain.protocol }//${ domain.apiDomain }`;
const RPC_URL = `${ REST_URL }/rpc`;

export default {
  getApiUrl(...uris: (string | string[])[]): string {
    const url = !isServer()
      ? `${ domain.protocol }//${ window.location.host }${ PROXY_API }`
      : REST_URL;

    return urlJoin(url, ...uris.flat());
  },

  getRestUrl(...uris: (string | string[])[]): string {
    return urlJoin(REST_URL, ...uris);
  },

  getRpcUrl({ disableProxy = false }: { disableProxy?: boolean } = {}): string {
    return !isServer() && !disableProxy
      ? `${ domain.protocol }//${ window.location.host }${ PROXY_API }/rpc`
      : RPC_URL;
  },

  getAssetsLocation(...uris: (string | string[])[]): string {
    return urlJoin(assetsConfig.location, ...uris);
  },
};
